'use client';
import { Table } from 'flowbite-react';
import { useTranslations } from '@power-core/toolkit';
import { type JSX, useEffect, useState } from 'react';
import type { DataTableProps } from './types';

const customTheme = {
	root: {
		base: 'w-full absolute text-left text-sm text-dark dark:text-n700_text_dark_mode',
		shadow: '',
		wrapper: '',
	},
	body: {
		base: 'group/body',
		cell: {
			base: 'px-3 py-1',
		},
	},
	head: {
		base: 'group/head text-sm font-medium capitalize text-dark dark:text-n700_text_dark_mode',
		cell: {
			base: 'bg-transparent px-3 py-1 font-medium',
		},
	},
	row: {
		base: 'group/row border-none',
		hovered: '',
		striped: 'odd:bg-n25_light even:bg-white dark:odd:bg-bg_dark dark:even:bg-card_dark',
	},
};

export const DataTable = <T extends Record<string, unknown>>({ columns, data, withMenuCell = false }: DataTableProps<T>): JSX.Element => {
	const [isMounted, setIsMounted] = useState(false);
	const t = useTranslations();

	useEffect(() => {
		setIsMounted(true);
	}, []);

	if (!isMounted) return <></>;

	const renderHeader = () => {
		return columns.map((column, i) => {
			return withMenuCell && i === columns.length - 1 ? (
				<Table.HeadCell key={String(column)} />
			) : (
				<Table.HeadCell key={String(column)}>{t(`T_${String(column).toUpperCase()}`) ?? ''}</Table.HeadCell>
			);
		});
	};

	return (
		<Table theme={customTheme} striped>
			<Table.Head>{renderHeader()}</Table.Head>
			<Table.Body className='h-full'>
				{data.map((item, index) => (
					<Table.Row key={index}>
						{columns.map((column) => (
							<Table.Cell key={String(column)} className={`${column === 'name' ? 'w-full' : 'w-12'}`}>
								{item[column] as React.ReactNode}
							</Table.Cell>
						))}
					</Table.Row>
				))}
			</Table.Body>
		</Table>
	);
};
